import { useEffect, useState } from "react";

// Sticky offsets for a page with a search bar under the sticky site header and a filter panel under the bar.
// Measured from the real elements so nothing scrolls through a gap when the header height changes.
// barRef is a callback ref, so the measuring starts once the bar is actually on the page.
export const useStickyOffsets = (gap = 12) => {
    const [bar, barRef] = useState<HTMLDivElement | null>(null);
    const [offsets, setOffsets] = useState({ barTop: 72, panelTop: 72 + 80 + gap });

    useEffect(() => {
        // The sticky wrapper around the bar can be taller than the bar itself.
        const barBox = bar?.parentElement ?? bar;
        const measure = () => {
            const headerHeight = document.querySelector("header")?.getBoundingClientRect().height ?? 0;
            const barHeight = barBox?.getBoundingClientRect().height ?? 0;
            const next = { barTop: headerHeight, panelTop: headerHeight + barHeight + gap };
            setOffsets((current) => (current.barTop === next.barTop && current.panelTop === next.panelTop ? current : next));
        };

        measure();
        const observer = new ResizeObserver(measure);
        const header = document.querySelector("header");
        if (header) observer.observe(header);
        if (barBox) observer.observe(barBox);
        window.addEventListener("resize", measure);
        // The header reports its own height changes (e.g. the website strip appearing once settings load).
        window.addEventListener("pb-header-resize", measure);
        return () => {
            observer.disconnect();
            window.removeEventListener("resize", measure);
            window.removeEventListener("pb-header-resize", measure);
        };
    }, [bar, gap]);

    return { barRef, ...offsets };
};
